import React from 'react'

import Text from '../text/Text'
import './PromotionHeaderTab.css'

interface OrderHeaderTypeProps {
    onChangeTab: (value: number) => void
    activeTab: number
}

export default function PromotionHeaderTab({
    onChangeTab,
    activeTab,
}: OrderHeaderTypeProps) {
    const handleOnChangeTab = (tab: number) => {
        onChangeTab(tab)
    }
    const onSelectNewTab = () => {
        handleOnChangeTab(0)
    }
    const onSelectProcessTab = () => {
        handleOnChangeTab(1)
    }

    return (
        <div className="promotion-header-tab-container">
            <div
                className={
                    activeTab === 0
                        ? 'promotion-header-text-container-selected'
                        : 'promotion-header-text-container'
                }
                onClick={onSelectNewTab}
            >
                <Text
                    label={'Vigentes'}
                    variant="promotion-header-text-style"
                    fontSize={16}
                    fontWeight={600}
                    color={'#184287'}
                />
            </div>
            <div
                className={
                    activeTab === 1
                        ? 'promotion-header-text-container-selected'
                        : 'promotion-header-text-container'
                }
                onClick={onSelectProcessTab}
            >
                <Text
                    label={'Vencidas'}
                    variant="promotion-header-text-style"
                    fontSize={16}
                    fontWeight={600}
                    color={'#184287'}
                />
            </div>
        </div>
    )
}
